export const trashStatistic = [
  {
    category: "Images",
    consumedSpace: '0 GB',
    colorPrimary: 'red'
  },
  {
    category: "Documents",
    consumedSpace: '0.007 GB',
    colorPrimary: 'blue'
  },
  {
    category: "Audio",
    consumedSpace: '0.0056 GB',
    colorPrimary: 'yellow'
  },
  {
    category: "Video",
    consumedSpace: '0 GB',
    colorPrimary: 'green'
  },
  {
    category: "Others",
    consumedSpace: '8.9 GB',
    colorPrimary: ''
  },

]